define('viewmodels/VisualAnalytics/WeightingsandThresholds',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'viewmodels/HeatMaps/InherentRiskHeatMap'], function (ko, router, appsecurity, navigation, app, system, logger, InherentRiskHeatMap) {

    var WViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        RiskAreaList: ko.observableArray([]),
        RiskFactorList: ko.observableArray([]),
        WeightingsList: ko.observableArray([]),
        BusinessUnitsList: ko.observableArray([]),
        WeightingsListSave: ko.observableArray([]),
        RAWeightingsList: ko.observableArray([]),
        OverallWeightingsListSave: ko.observableArray([]),
        WeightingsType: ko.observable(),
        Assessmenttype: ko.observable(),
        GetAllRiskAreas: GetAllRiskAreas,
        HeaderText: ko.observable(),
        ProfileofAssessment: ko.observable(),
        saveWeightings: saveWeightings,
        ClickedRiskAreaId: ko.observable(),
        ClickedRiskAreaName: ko.observable(),
        RAId: ko.observable(),
        RAName: ko.observable(),
        copyData: copyData,//this function is for copy to all functionality
        RiskAreaTabClick: RiskAreaTabClick,
        ClickNumber: ko.observable(0),
        Closepopup: Closepopup,
        AssessmentName: ko.observable()

    };
    return WViewModel;

    var UserTableObj = false;



    function activate() {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            $(document).on('change', 'input', function (e) {

                GetTotalWeightings();

            });

            $(document).on('keydown', 'input', function (e) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/') + 1);
                var id = $(this).attr('id');
                var result = '', controlID = '', rows = 0;
                if ((id.substring(0, 13)) == "txt_weighting") {
                    result = id.substring(("txt_weighting").length, id.length);
                    controlID = 'txt_weighting';
                    rows = WViewModel.RiskFactorList().length;
                    columns = WViewModel.BusinessUnitsList().length;
                }
                else if ((id.substring(0, 14)) == "txt_Oweighting") {
                    result = id.substring(("txt_Oweighting").length, id.length);
                    controlID = 'txt_Oweighting';
                    rows = WViewModel.RiskAreaList().length - 1// removing the Overall AML Inherent Weightings from the list;
                    columns = WViewModel.BusinessUnitsList().length;
                }
                else if ((id.substring(0, 21)) == "GetTotalWeightingsBUL") {
                    result = id.substring(("GetTotalWeightingsBUL").length, id.length);
                    controlID = 'GetTotalWeightingsBUL';
                    rows = WViewModel.BusinessUnitsLowestLevelList().length;
                    columns = WViewModel.RiskAreaList().length;
                } else if ((id.substring(0, 17)) == "txt_BULOweighting") {
                    result = id.substring(("txt_BULOweighting").length, id.length);
                    controlID = "txt_BULOweighting";
                    rows = WViewModel.RiskAreaList().length - 1;
                    columns = WViewModel.BusinessLevelDetailsList().length - 1;

                }


                if (e.which == 9 && filename == "InherentHeatMapAnalysis" && rows > 1) {

                    var columnandrownuo = result.indexOf("_");

                    if (controlID == "txt_Oweighting") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.length));
                    }
                    else if (controlID == "txt_weighting") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));

                    }
                    else if (controlID == "GetTotalWeightingsBUL") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));

                    }
                    else if (controlID == "txt_BULOweighting") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }

                    rowno = rowno + 1;
                    if (rowno == rows) {
                        rowno = 0;
                        columnno = columnno + 1;
                    }
                    for (var i = columnno; i < columns; i++) {
                        if (controlID == "txt_Oweighting") {
                            //  e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno;
                            //  $("#" + tobefocusedid).focus();
                            // $("#" + tobefocusedid).select();

                        } else if (controlID == "txt_weighting") {
                            //e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + WViewModel.RAId()
                        }
                        else if (controlID == "GetTotalWeightingsBUL") {
                            //e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + WViewModel.ClickedLevelDetailId()
                            //  $("#" + tobefocusedid).focus();
                            // $("#" + tobefocusedid).select();
                        }
                        else if (controlID == "txt_BULOweighting") {
                            // e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + WViewModel.ClickedLevelDetailId()
                            // $("#" + tobefocusedid).focus();
                            // $("#" + tobefocusedid).select();
                        }
                        if ($("#" + tobefocusedid).prop('disabled')) {
                            columnno = columnno + 1;
                        }
                        else {
                            break;
                        }
                    }
                    if (columns == columnno | columnandrownuo == -1 | isNaN(rowno)) {
                        //do nothing to make tab work as per its functionality
                    }
                    else if (controlID == "txt_Oweighting") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno;
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();

                    } else if (controlID == "txt_weighting") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + WViewModel.RAId()
                        if ($("#" + tobefocusedid).prop('disabled')) {

                        }
                        else {
                            $("#" + tobefocusedid).focus();
                            $("#" + tobefocusedid).select();
                        }
                    }
                    else if (controlID == "GetTotalWeightingsBUL") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + WViewModel.ClickedLevelDetailId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                    else if (controlID == "txt_BULOweighting") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + WViewModel.ClickedLevelDetailId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }


                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    }

    function Closepopup() {
        try {
            $('#HeatMapPopUp').modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Closepopup() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }

    }

    function Closepopup() {
        try {
            $('#HeatMapPopUp').modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Closepopup() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }

    }



    //-------------------------------copy to all sub method starts here------------------------------------------------------------------
    function copyDataRA() {
        try {
            $('#loadingMainImgDivAMLRA_WIA').show();
            $('#RiskAreaTabDiv').hide();
            var cols = WViewModel.BusinessUnitsList().length;
            $("#lblAMLError-" + WViewModel.RAId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var weightingsvalue = [];
            if (WViewModel.RAId() != "AML_OVERALL") {
                rows = WViewModel.RiskFactorList().length;
            } else {
                rows = WViewModel.RiskAreaList().length - 1;
            }
            var Weightingsvalue = [];
            for (var i = 0; i < rows; i++) {
                if (WViewModel.RAId() != "AML_OVERALL") {
                    var txtValue = $($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;

                } else {
                    var txtValue = $($('#tblAMLWeightingsOverall tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                }
                if (txtValue == "") {

                    $("#lblAMLError-" + WViewModel.RAId()).show();
                    $("#lblAMLError-" + WViewModel.RAId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblAMLError-" + WViewModel.RAId()).show();
                        $("#lblAMLError-" + WViewModel.RAId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblAMLError-" + WViewModel.RAId()).show();
                        $("#lblAMLError-" + WViewModel.RAId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblAMLError-" + WViewModel.RAId()).show();
                        $("#lblAMLError-" + WViewModel.RAId()).text('Decimal upto 2 places is allowed');
                        valid = 1;
                        break;
                    }
                    else {
                        Weightingsvalue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                WViewModel.ErrorStatus(1);
                $('#loadingMainImgDivAMLRA_WIA').hide();
                $('#RiskAreaTabDiv').show();
            }
            if (valid == 0) {
                if (WViewModel.RAId() != "AML_OVERALL") {
                    WViewModel.WeightingsList([]);
                    for (var i = 0; i < rows; i++) {
                        selectedRowId = WViewModel.RiskFactorList()[i].RiskFactorId();
                        for (var j = 0; j < cols; j++) {

                            selectedColId = WViewModel.BusinessUnitsList()[j].BusinessUnit_ID();
                            wValue = Weightingsvalue[i];
                            var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                            WViewModel.WeightingsList.push(newObj);
                        }
                    }
                    $('#tblAMLWeightings-' + WViewModel.RAId()).remove();
                    WeightingsTable(1);
                    GetTotalWeightings();
                }
                else {
                    WViewModel.RAWeightingsList([]);
                    for (var i = 0; i < rows; i++) {
                        selectedRowId = WViewModel.RiskAreaList()[i].RiskAreaId();
                        for (var j = 0; j < cols; j++) {

                            selectedColId = WViewModel.BusinessUnitsList()[j].BusinessUnit_ID();
                            wValue = Weightingsvalue[i];
                            var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                            WViewModel.RAWeightingsList.push(newObj);
                        }
                    }
                    $('#tblAMLWeightingsOverall').remove();
                    OverallWeightingsTable(1);
                    GetTotalWeightings();
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
            $('#loadingMainImgDivAMLRA_WIA').hide();
            $('#RiskAreaTabDiv').show();
        }
    }
    //-------------------------------copy to all sub method ends here---------------------------------------------------------------------
    //-------------------------------copy to all functionality starts here------------------------------------------------------------------
    function copyData() {
        try {
            if (WViewModel.WeightingsType() == 'RA') {
                copyDataRA();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyData() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------copy to all functionality ends here--------------------------------------------------------------------
    //-------------------adds new tab for every area starts here------------------------------------------------------------
    function addNewDivTab(data) {
        try {
            $('#RiskAreaTabDiv').append(
                '<div id="AMLTabDiv-' + data.RiskAreaId() + '" style="overflow:hidden;"></div>');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTab() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    }
    //-------------------adds new tab for every area starts here------------------------------------------------------------
    //--------------------------------------------------------GetAllARiskAreas Method starts here------------------------------------------------------------
    function GetAllRiskAreas(list, Assessment, Profile_Id, AssessmentName) {
        try {
            //document.getElementById('RiskAreaTabDiv').innerHTML = '';
            WViewModel.ProfileofAssessment(Profile_Id);
            WViewModel.Assessmenttype(Assessment);
            WViewModel.AssessmentName(AssessmentName + ' Inherent Risk Weightings');
            //if (WViewModel.Assessmenttype() == 'AML') {
            //    WViewModel.HeaderText('AML Inherent Weightings ')
            //}
            //else if (WViewModel.Assessmenttype() == 'SANC') {
            //    WViewModel.HeaderText('Sanctions Inherent Weightings')
            //}
            WViewModel.BusinessUnitsList(list);
            //    $('#RiskAreaTabDiv').remove();
            try {
                $.ajax({
                    url: "/api/Visualization/GetAllRiskAreas",
                    data: { "AssessmentType": WViewModel.Assessmenttype(), "AreaType": "ALL", "Profile": WViewModel.ProfileofAssessment() },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);



            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in WeightingsandThresholds.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    WViewModel.RiskAreaList([]);
                    if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "" && jsonResult[0].RiskAreaName != null) {
                        if (WViewModel.Assessmenttype() == "AML")
                            jsonResult[jsonResult.length] = { RiskAreaId: "AML_OVERALL", RiskAreaName: "Overall AML Inherent Weightings", RiskAreaType: "AML" }
                        else
                            jsonResult[jsonResult.length] = { RiskAreaId: "AML_OVERALL", RiskAreaName: "Overall Sanctions Inherent Weightings", RiskAreaType: "SANC" }
                        var mappedRiskAreaList = $.map(jsonResult, function (result) {
                            var RiskAreaModelObj = new RiskAreaModel(result);
                            addNewDivTab(RiskAreaModelObj);
                            return RiskAreaModelObj;
                        });
                        WViewModel.RiskAreaList(mappedRiskAreaList);
                        $('#RaTab').tabs();

                        $('#RaTab').tabs({ active: 0 });
                        $($('#RiskAreaUl li').get(0)).trigger('click');
                        scrollableTabs();
                    }

                    else if (jsonResult[0].RiskAreaName == null)
                        app.showMessage("Risk Areas are not yet configured for this profile of assessment. Please configure the Risk Areas to before setting Thresholds", "Error in Fetching Risk Areas", ["OK"])
                            .then(function (option) {
                                if (option == "OK")
                                    router.navigate("configuration/RisksAreasfactors", true);
                            })
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AtViewModel), true);

                    //else {

                    //    app.showMessage("Risk Area configurations not in place.", "Error", ["OK"]);
                    //}

                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in WeightingsandThresholds.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in WeightingsandThresholds.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in WeightingsandThresholds.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllRiskAreas() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    }
    //--------------------------------------------------------GetAllRiskAreas Method ends here--------------------------------------------------------------
    //Get Risk factor starts here
    function GetRiskFactors() {
        try {
            GetAllRiskFactorAjax = {
                url: "/api/Visualization/GetAllRiskfactorAreaWise",
                data: { "RiskAreaId": WViewModel.RAId(), "AssessmentType": WViewModel.Assessmenttype(), "Profile_Id": WViewModel.ProfileofAssessment() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetAllRiskFactorAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskFactors() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult[0].Flag == 1) {
                        var mappedRiskFactors = $.map(jsonResult, function (result) {
                            return new RiskFactorModel(result);
                        });
                        WViewModel.RiskFactorList([]);
                        WViewModel.RiskFactorList(mappedRiskFactors);
                        GetWeightings();
                    }
                    else {
                        app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);
                    }
                } else {
                    app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactor() method in WeightingsandThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in WeightingsandThresholds.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in WeightingsandThresholds.js';
                logger.logMessage(msg);
            }
        }
    }
    //GetRiask Factor ends here

    //Risk area tab click
    function RiskAreaTabClick(data, event) {
        try {
            $('#loadingMainImgDivAMLRA_WIA').show();
            $('#RiskAreaTabDiv').hide();
            WViewModel.ClickedRiskAreaId(data.RiskAreaId());
            WViewModel.ClickedRiskAreaName(data.RiskAreaName());


            if (WViewModel.ClickNumber() == 0) {
                $('#' + WViewModel.ClickedRiskAreaId()).removeClass('ui-tabs-active ui-state-active');
                $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
            }
            else {
                $('#' + WViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
                $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
            }
            WViewModel.RAName(data.RiskAreaName());
            WViewModel.RAId(data.RiskAreaId());
            if (WViewModel.RAId() == "AML_OVERALL") {
                //$('#AMLTabDiv-' + WViewModel.RAId()).show();
                WViewModel.WeightingsType('RA');
                GetOverallWeightings();

            }
            else {
                WViewModel.WeightingsType('RA');
                GetRiskFactors();
            }
            WViewModel.ClickNumber(WViewModel.ClickNumber() + 1);


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    }
    //Risk Area tab click ends here

    //Get Weightings
    function GetWeightings() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            GetWeightingsAjax = {
                url: "/api/Visualization/GetAllRiskAreaWeightings?RiskAreaId=" + WViewModel.RAId() + "&RiskAreaType=" + WViewModel.Assessmenttype() + "&Profile_Id=" + WViewModel.ProfileofAssessment(),
                headers: headers,
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify($.map(WViewModel.BusinessUnitsList(), function (result) {

                    return { BuId: result.BusinessUnit_ID(), BuName: result.BusinessUnit_Name() };

                }))
            };
            $.ajax(GetWeightingsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkWeighting = 1;
                    WViewModel.WeightingsList(mappedWeightings);
                    WeightingsTable(checkWeighting);
                    GetTotalWeightings();
                }
                else {
                    checkWeighting = 0;
                    WeightingsTable(checkWeighting);
                    GetTotalWeightings();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

    }
    //Get Weightings ends here


    //save weightings start here
    function saveWeightings() {
        try {
            $('#loadingMainImgDivAMLRA_WIA').show();
            $('#RiskAreaTabDiv').hide();
            $("#lblAMLError-" + WViewModel.RAId()).hide();
            var cols = WViewModel.BusinessUnitsList().length;
            if (WViewModel.RAId() == "AML_OVERALL") {
                var rows = WViewModel.RiskAreaList().length - 1;
                var valid = 1;
                var check = 0;
                for (var i = 0; i < cols; i++) {
                    var sum = 0;
                    for (var j = 0; j < rows; j++) {
                        if ($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                            $($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                        }
                        if (!$.isNumeric($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                            valid = 0;
                            $("#lblAMLError-" + WViewModel.RAId()).show();
                            $("#lblAMLError-" + WViewModel.RAId()).text('Non-numeric values are not allowed.');
                            check = 1;
                        }
                        else if ($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                            valid = 0;
                            $("#lblAMLError-" + WViewModel.RAId()).show();
                            $("#lblAMLError-" + WViewModel.RAId()).text('Value should be in range of (0-100).');
                            check = 1;
                        }
                        else {
                            sum += parseFloat($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                        }
                    }
                    if (sum != 100 && sum != 0) {
                        if (check == 0) {
                            valid = 0;
                            $("#lblAMLError-" + WViewModel.RAId()).show();
                            $("#lblAMLError-" + WViewModel.RAId()).text('The total for weightings across factors should be 100% for business unit ' + WViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '.');
                            break;
                        }
                    }
                }
                if (valid == 0) {
                    WViewModel.ErrorStatus(1);
                }
                if (valid == 1) {
                    try {
                        buildSaveOverallWeightingsList();
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        $.ajax({
                            url: "/api/Visualization/SaveOverallWeightings?RiskAreaType=" + WViewModel.Assessmenttype() + "&Filter=A&RiskAreaId=" + WViewModel.RAId() + "&Profile_Id=" + WViewModel.ProfileofAssessment(),
                            headers: headers,
                            type: "POST",
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify($.map(WViewModel.OverallWeightingsListSave(), function (item) {
                                return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                            }))
                        })
                            .success(ajaxSuccessOverall)
                            .fail(ajaxFailOverall);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveOverallWeightings() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }

                    function ajaxSuccessOverall(jsonResult, status) {
                        try {
                            if (jsonResult != null && jsonResult > 0) {
                                $('#tblAMLWeightingsOverall').remove();
                                checkOverallWeighting = 1;
                                logger.logSuccess('Overall Inherent Weightings saved successfully.', 'Success', system.getModuleId(WViewModel), true);
                                GetOverallWeightings();
                                GetTotalWeightings();


                            }
                            else {
                                logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(WViewModel), true);
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveOverallWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }

                    function ajaxFailOverall(error, status) {
                        try {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveOverallWeightings() method in AMLInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveOverallWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                }

            }
            else {
                var rows = WViewModel.RiskFactorList().length;
                var valid = 1;
                var check = 0;
                for (var i = 0; i < cols; i++) {
                    var sum = 0;
                    for (var j = 0; j < rows; j++) {
                        if ($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                            $($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                        }
                        if (!$.isNumeric($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                            valid = 0;
                            $("#lblAMLError-" + WViewModel.RAId()).show();
                            $("#lblAMLError-" + WViewModel.RAId()).text('Non-numeric values are not allowed.');
                            check = 1;
                        }
                        else if ($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                            valid = 0;
                            $("#lblAMLError-" + WViewModel.RAId()).show();
                            $("#lblAMLError-" + WViewModel.RAId()).text('Value should be in range of (0-100).');
                            check = 1;
                        }
                        else if ((!isNaN($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) && ($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value % 1 != 0) && (!checkDecimal($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value))) {
                            valid = 0;
                            $("#lblAMLError-" + WViewModel.RAId()).show();
                            $("#lblAMLError-" + WViewModel.RAId()).text('Decimal upto 2 places is allowed.');
                            check = 1;
                        }
                        else {
                            sum += parseFloat($($('#tblAMLWeightings-' + WViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                        }
                    }
                    if (sum != 100 && sum != 0) {
                        if (check == 0) {
                            valid = 0;
                            $("#lblAMLError-" + WViewModel.RAId()).show();
                            $("#lblAMLError-" + WViewModel.RAId()).text('The total for weightings across factors should be 100% for business unit ' + WViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '.');
                            break;
                        }
                    }
                }
                if (valid == 0) {
                    WViewModel.ErrorStatus(1);
                }
                if (valid == 1) {
                    try {
                        buildSaveRAWeightingsList();
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        $.ajax({
                            url: "/api/Visualization/SaveRiskFactorWeightings?RiskAreaType=" + WViewModel.Assessmenttype() + "&Filter=F&RiskAreaId=" + WViewModel.RAId() + "&Profile_Id=" + WViewModel.ProfileofAssessment(),
                            headers: headers,
                            type: "POST",
                            contentType: 'application/json',
                            dataType: 'json',
                            async: false,
                            data: JSON.stringify($.map(WViewModel.WeightingsListSave(), function (item) {
                                return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                            }))
                        })
                            .success(ajaxSuccess)
                            .fail(ajaxFail);
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxCcall in saveWeightings() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }

                    function ajaxSuccess(jsonResult, status) {
                        try {
                            if (jsonResult != null && jsonResult > 0) {
                                $('#tblAMLWeightings-' + WViewModel.RAId()).remove();
                                checkWeighting = 1;
                                GetWeightings();
                                GetTotalWeightings();
                                logger.logSuccess('Weightings for Risk Area saved successfully.', 'Success', system.getModuleId(WViewModel), true);
                            } else {
                                logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(WViewModel), true);
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }

                    function ajaxFail(error, status) {
                        try {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightings() method in AMLInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }


    }

    //save weightingd ends here
    //build save weightings list for overall starts here
    function buildSaveOverallWeightingsList() {
        try {
            WViewModel.OverallWeightingsListSave([]);
            var rows = WViewModel.RiskAreaList().length - 1;
            var cols = WViewModel.BusinessUnitsList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_Oweighting' + i + '_' + j;
                    var newObj = new WeightingModel({
                        'Id': WViewModel.RiskAreaList()[i].RiskAreaId(), 'BuId': WViewModel.BusinessUnitsList()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    WViewModel.OverallWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveWeightingsList() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    //build save weightings list for overall ends here
    //build save weightings list starts here
    function buildSaveRAWeightingsList() {
        try {
            WViewModel.WeightingsListSave([]);
            var rows = WViewModel.RiskFactorList().length;
            var cols = WViewModel.BusinessUnitsList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_weighting' + i + '_' + j + '_' + WViewModel.RAId();
                    var newObj = new WeightingModel({
                        'Id': WViewModel.RiskFactorList()[i].RiskFactorId(), 'BuId': WViewModel.BusinessUnitsList()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    WViewModel.WeightingsListSave().push(newObj);
                }

            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveRAWeightingsList() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    //build save weightings list ends here

    //Get Total weightings starts here
    function GetTotalWeightings() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);
        if (WViewModel.RAId() == "AML_OVERALL") {

            for (var k = 0; k < WViewModel.BusinessUnitsList().length; k++) {
                var sum = parseFloat(0);
                for (var i = 0; i < WViewModel.RiskAreaList().length - 1; i++) {

                    var x = "#txt_Oweighting" + i + "_" + k;
                    sum = parseFloat(sum) + parseFloat($(x).val());
                }
                var rowcount = k;
                if (isNaN(sum)) {
                    $("#txt_Oweighting" + rowcount + WViewModel.RAId()).val(0);
                } else {
                    $("#txt_Oweighting" + rowcount + WViewModel.RAId()).val(sum);
                }
                if (sum == 100) {
                    $("#txt_Oweighting" + rowcount + WViewModel.RAId()).css('color', '#000000')
                    $("#txt_Oweighting" + rowcount + WViewModel.RAId()).css("background-color", "#cccccc")
                } else {
                    $("#txt_Oweighting" + rowcount + WViewModel.RAId()).css('color', 'red')

                }
            }
        } else {
            for (var k = 0; k < WViewModel.BusinessUnitsList().length; k++) {
                var sum = parseFloat(0);
                for (var i = 0; i < WViewModel.RiskFactorList().length; i++) {

                    var x = "#txt_weighting" + i + "_" + k + "_" + WViewModel.RAId();
                    sum = parseFloat(sum) + parseFloat($(x).val());
                }
                var rowcount = k;
                if (isNaN(sum)) {
                    $("#txt_weighting" + rowcount + WViewModel.RAId()).val(0);
                } else {
                    $("#txt_weighting" + rowcount + WViewModel.RAId()).val(sum);
                }
                if (sum == 100) {
                    $("#txt_weighting" + rowcount + WViewModel.RAId()).css('color', '#000000')
                    $("#txt_weighting" + rowcount + WViewModel.RAId()).css("background-color", "#cccccc")
                } else {
                    $("#txt_weighting" + rowcount + WViewModel.RAId()).css('color', 'red')

                }
            }
        }
    }
    //Get Total Weightings ends here

    //building weightings starts here
    function WeightingsTable(checkWeighting) {
        try {
            var selectedRow, selectedCol;
            var j = WViewModel.BusinessUnitsList().length;
            var rows = WViewModel.RiskFactorList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < WViewModel.BusinessUnitsList().length; i++) {
                colHeight = Math.ceil(WViewModel.BusinessUnitsList()[i].BusinessUnit_Name().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucolumnheight = tdHeight / 2;
            $('#outerdiv').show();
            for (var i = 0; i < WViewModel.RiskAreaList().length; i++) {
                $('#AMLTabDiv-' + WViewModel.RiskAreaList()[i].RiskAreaId()).show();
            }
            for (var i = 0; i < WViewModel.RiskAreaList().length; i++) {
                document.getElementById('AMLTabDiv-' + WViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
            }
            var TabData =
                '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (WViewModel.appsecurity.WriteAccess() == true) {
                TabData += '<span id="spnAMLInherent" class="pull-right">' +
                    '<button type="button" class="btn btn-primary btn-sm" id="btnAMLCopy-' + WViewModel.RAId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                    '<i class="fa fa-copy"></i> Copy to All' +
                    '</button>' +
                    '<button type="button" class="btn btn-success btn-sm" id="btnAMLSave-' + WViewModel.RAId() + '" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                    '<i class="fa fa-check"></i> Save' +
                    '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-2 col-lg-1 control-label no-padding control-label-key">Risk Area Name : </label>' +
                '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label fnormal control-label-val">' + WViewModel.RAName() + '</label>' +
                '</div><label id="lblAMLError-' + WViewModel.RAId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
                '<label id="lblAMLError" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none">No Data Available.</label>' +


                //Corner cell
                '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                '<tr>' +
                '<th class="site_name label-info headcol-min1 text-center" title="Business Unit Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Name</th>' +


                '</tr>' +
                '<tr>' +
                '<th class="site_name label-info headcol-min1 text-center" title="Risk Factor Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Factor Name</th>' +
                '</tr>' +
                '</table>' +
                '</div>' +
                //Corner cell end


                //Header Business units
                '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + WViewModel.RAId() + '" style="width:65%;">' +
                '<table>' +
                '<tr>'
            for (var i = 0; i < j; i++) {


                TabData += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + WViewModel.BusinessUnitsList()[i].BusinessUnit_ID() + '" title="' + WViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '">' + WViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '</th>';

            }
            TabData += '</tr>' +

                '</table>' +
                '</div>' +

                //Header Business units end

                //Row headers
                '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + WViewModel.RAId() + '" style="width:100%">' +
                '<table>';
            for (var i = 0; i < rows; i++) {
                var factText = WViewModel.RiskFactorList()[i].RiskFactorName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;


                TabData += '<tr><td class="tbl-weightings-cell Weightingsheader" style="min-height:42px;height:' + colHeight + 'em !important;">';
                TabData += factText;
                TabData += '</td></tr>';
            }
            TabData += '</table></div>' +
                //Row headers end




                //Data
                '<div class="wclscscroll table-content" id="clscroll-content' + WViewModel.RAId() + '" style="width:65%;">' +
                '<table id="tblAMLWeightings-' + WViewModel.RAId() + '" ><tbody>';

            for (var i = 0; i < rows; i++) {
                TabData += '<tr id="' + WViewModel.RiskFactorList()[i].RiskFactorId() + '">';
                var factText = WViewModel.RiskFactorList()[i].RiskFactorName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                for (var k = 0; k < (j); k++) {
                    if (WViewModel.appsecurity.WriteAccess() == false) {

                        TabData += '<td id=" ' + WViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" class=" disabled tbl-weightings-cell long weightingspadding" style="height:' + colHeight + 'em !important;"><div class="input-group">';

                    }
                    else {
                        TabData += '<td id=" ' + WViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" class="tbl-weightings-cell long weightingspadding" style="height:' + colHeight + 'em !important;"><div class="input-group">';
                    }
                    selectedCol = WViewModel.BusinessUnitsList()[k].BusinessUnit_ID();
                    if (checkWeighting == 1) {
                        var check_new = true;
                        for (var val = 0; val < WViewModel.WeightingsList().length; val++) {
                            if (WViewModel.WeightingsList()[val].BuId() == WViewModel.BusinessUnitsList()[k].BusinessUnit_ID() && WViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                // var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue' : 0 });
                                //WViewModel.WeightingsList().push(newObj);
                                TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + WViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                            else if (WViewModel.WeightingsList()[val].Id() == WViewModel.RiskFactorList()[i].RiskFactorId() && WViewModel.WeightingsList()[val].BuId() == WViewModel.BusinessUnitsList()[k].BusinessUnit_ID()) {


                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_weighting' + i + '_' + k + '_' + WViewModel.RAId() + '" value="' + WViewModel.WeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                        }
                        if (check_new) {
                            if (WViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                WViewModel.WeightingsList().push(newObj);
                                TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + WViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                            else {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                WViewModel.WeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + WViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                        }
                    } else {
                        if (WViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            WViewModel.WeightingsList().push(newObj);
                            TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + WViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                        else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            WViewModel.WeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + WViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                    }

                    TabData += '</div></td>';


                }
                TabData += '</tr>';
            }


            TabData += '</tbody></table></div>';
            //Total  cell

            TabData += '<div class="wclscscroll corner-header">' +
                '<table>' +
                '<tr>';

            TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            TabData += "Total"
            TabData += '</td>' +

                '</tr>' +

                '</table>' +
                '</div>' +
                //Total cell end
                //Total Data
                '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + WViewModel.RAId() + '">' +
                '<table>' +
                '<tr>'
            for (var m = 0; m < WViewModel.BusinessUnitsList().length; m++) {
                TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabData += '<input type="text" disabled style="background-color: #cccccc;"  class="form-control form-controlWT" id="' + 'txt_weighting' + m + WViewModel.RAId() + '"></input><span class="input-group-addon">%</span>';
                TabData += '</td>';

                //ko.applyBindingsToNode($('#txt_weighting-' + m + WViewModel.RAId()), { event: { keyup: WViewModel.InputChange } }, WViewModel);
            }
            TabData += '</tr>' +
                '</table></div>';
            //Total Dataend

            document.getElementById('AMLTabDiv-' + WViewModel.RAId()).innerHTML = TabData;
            ko.applyBindingsToNode($('#btnAMLSave-' + WViewModel.RAId()), { click: WViewModel.saveWeightings }, WViewModel);
            ko.applyBindingsToNode($('#btnAMLCopy-' + WViewModel.RAId()), { click: WViewModel.copyData }, WViewModel);


            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1); k++) {

                    ko.applyBindingsToNode($('#txt_weighting' + i + '_' + k + '_' + WViewModel.RAId()), { event: { keyup: WViewModel.InputChange } }, WViewModel);

                }
            }

            $("#clscroll-content" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-row-headers" + WViewModel.RAId()).scrollTop($("#clscroll-content" + WViewModel.RAId()).scrollTop());
                $("#clscroll-column-headers" + WViewModel.RAId()).scrollLeft($("#clscroll-content" + WViewModel.RAId()).scrollLeft());
                $("#clscroll-column-footer" + WViewModel.RAId()).scrollLeft($("#clscroll-content" + WViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-headers" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + WViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + WViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-footer" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + WViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + WViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-row-headers" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + WViewModel.RAId()).scrollTop($("#clscroll-row-headers" + WViewModel.RAId()).scrollTop());
            });
            $('#loadingMainImgDivAMLRA_WIA').hide();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingsTable() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
            $('#loadingMainImgDivAMLRA_WIA').hide();
            $('#RiskAreaTabDiv').show();
        }
    }
    //building weightings ends here

    //GetOverall weightings sarts here
    function GetOverallWeightings() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            GetOverAllWeightingsAjax = {
                url: "/api/Visualization/GetOverallWeightings?Profile_Id=" + WViewModel.ProfileofAssessment() + "&RiskAreaType=" + WViewModel.Assessmenttype() + "&Type=A",
                headers: headers,
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify($.map(WViewModel.BusinessUnitsList(), function (result) {

                    return { BuId: result.BusinessUnit_ID(), BuName: result.BusinessUnit_Name() };

                }))
            };
            $.ajax(GetOverAllWeightingsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetOverallWeightings() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkOverallWeighting = 1;
                    WViewModel.RAWeightingsList([]);
                    WViewModel.RAWeightingsList(mappedWeightings);
                    OverallWeightingsTable(checkOverallWeighting);
                    GetTotalWeightings();
                }
                else {
                    checkOverallWeighting = 0;
                    OverallWeightingsTable(checkOverallWeighting);
                    GetTotalWeightings();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetOverallWeightings() method in WeightingsandThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverallWeightings() method in WeightingsandThresholds.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetOverallWeightings() method in WeightingsandThresholds.js';
                logger.logMessage(msg);
            }
        }


    }
    //GetOverallweightings ends here

    //Building Overallweightings and security for the table starts here
    function OverallWeightingsTable(checkOverallWeighting) {
        try {
            var selectedRow, selectedCol;
            var rows = WViewModel.RiskAreaList().length - 1;
            var j = WViewModel.BusinessUnitsList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < WViewModel.RiskAreaList().length; i++) {
                document.getElementById('AMLTabDiv-' + WViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
            }
            for (var i = 0; i < WViewModel.BusinessUnitsList().length; i++) {
                colHeight = Math.ceil(WViewModel.BusinessUnitsList()[i].BusinessUnit_Name().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucolumnheight = tdHeight / 2;
            //for (var i = 0; i <= WViewModel.RiskAreaList().length; i++) {
            //    document.getElementById('AMLTabDiv-' + WViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
            //}

            var TabDataOverAll = '</br>' +
                '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (WViewModel.appsecurity.WriteAccess() == true) {
                TabDataOverAll += '<span id="spnAMLInherent" class="pull-right">' +
                    '<button type="button" class="btn btn-primary btn-sm" id="btnAMLCopyOverall" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +

                    '<i class="fa fa-copy"></i>Copy to All' +
                    '</button>' +
                    '<button type="button" class="btn btn-success btn-sm" id="btnAMLSaveOverall" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                    '<i class="fa fa-check"></i>Save' +
                    '</button></span>';
            }


            TabDataOverAll += '<label  style="padding-left:1em" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label control-label-border">Overall Inherent Weightings</label>' +
                '</div><label id="lblAMLError-' + WViewModel.RAId() + '" class="control-label alert alert-danger col-xs-12 col-sm-12 col-md-12 col-lg-12 alerts-inherent" style="display:none"></label>' +
                //Corner cell
                '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                '<tr>' +
                '<th class="site_name label-info headcol-min1 text-center" title="Business Unit" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Name</th>' +


                '</tr>' +
                '<tr>' +
                '<th class="site_name label-info headcol-min1 text-center" title="Risk Area Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Area Name</th>' +
                '</tr>' +
                '</table>' +
                '</div>' +
                //Corner cell end
                //Header Business units
                '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + WViewModel.RAId() + '" style="width:65%;">' +
                '<table>' +
                '<tr>'
            for (var i = 0; i < j; i++) {


                TabDataOverAll += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + WViewModel.BusinessUnitsList()[i].BusinessUnit_ID() + '" title="' + WViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '">' + WViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '</th>';

            }
            TabDataOverAll += '</tr>' +

                '</table>' +
                '</div>' +

                //Header Business units end
                //Row headers
                '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + WViewModel.RAId() + '" style="width:100%">' +
                '<table>';
            for (var i = 0; i < rows; i++) {
                var factText = WViewModel.RiskAreaList()[i].RiskAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;


                TabDataOverAll += '<tr><td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader">';
                TabDataOverAll += WViewModel.RiskAreaList()[i].RiskAreaName();
                TabDataOverAll += '</td></tr>'
            }
            TabDataOverAll += '</table></div>' +
                //Row headers end
                //Data
                '<div class="wclscscroll table-content" id="clscroll-content' + WViewModel.RAId() + '" style="width:65%;">' +
                '<table  id="tblAMLWeightingsOverall"><tbody>';
            for (var i = 0; i < rows; i++) {
                var factText = WViewModel.RiskAreaList()[i].RiskAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = WViewModel.RiskAreaList()[i].RiskAreaId();
                TabDataOverAll += '<tr id="' + WViewModel.RiskAreaList()[i].RiskAreaId() + '">';
                for (var k = 0; k < (j); k++) {
                    // TabDataOverAll += '<td class="tbl-weightings-cell">';
                    if (WViewModel.appsecurity.WriteAccess() == false) {
                        TabDataOverAll += '<td id="' + WViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="disabled tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    }
                    else {
                        TabDataOverAll += '<td id="' + WViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';

                    }
                    selectedCol = WViewModel.BusinessUnitsList()[k].BusinessUnit_ID();
                    if (checkOverallWeighting == 1) {
                        var check_new = true;
                        for (var val = 0; val < WViewModel.RAWeightingsList().length; val++) {
                            if (WViewModel.RAWeightingsList()[val].BuId() == WViewModel.BusinessUnitsList()[k].BusinessUnit_ID() && WViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                // var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue' : 0 });
                                //WViewModel.WeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                            else if (WViewModel.RAWeightingsList()[val].Id() == WViewModel.RiskAreaList()[i].RiskAreaId() && WViewModel.RAWeightingsList()[val].BuId() == WViewModel.BusinessUnitsList()[k].BusinessUnit_ID()) {
                                TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '"value="' + WViewModel.RAWeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                        }
                        if (check_new) {
                            if (WViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                WViewModel.RAWeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                            else {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                WViewModel.RAWeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '"value="0"></input><span class="input-group-addon">%</span>';
                            }
                        }
                    } else {
                        if (WViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            WViewModel.RAWeightingsList().push(newObj);
                            TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + WViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                        else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            WViewModel.RAWeightingsList().push(newObj);
                            TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '"value="0"></input><span class="input-group-addon">%</span>';
                        }
                    }
                    TabDataOverAll += '</div></td>';
                }

                TabDataOverAll += '</tr>';
                //if (i == rows - 1) {


                // }



            }


            TabDataOverAll += '</tbody></table></div>';
            //totalheader table
            //Total  cell

            TabDataOverAll += '<div class="wclscscroll corner-header">' +
                '<table>' +
                '<tr>';

            TabDataOverAll += '<td   style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            TabDataOverAll += "Total"
            TabDataOverAll += '</td>' +

                '</tr>' +

                '</table>' +
                '</div>' +
                //Total cell end
                //Total Data
                '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + WViewModel.RAId() + '">' +
                '<table>' +
                '<tr>'
            for (var i = 0; i < WViewModel.BusinessUnitsList().length; i++) {
                TabDataOverAll += '<td style="height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabDataOverAll += '<input type="text" disabled style="background-color:#cccccc"class="form-control form-controlWT" id="' + 'txt_Oweighting' + i + WViewModel.RAId() + '"></input><span class="input-group-addon">%</span>';
                TabDataOverAll += '</td>';
            }
            TabDataOverAll += '</tr>' +
                '</table></div>';
            //Total Dataend
            //end of toatl table

            document.getElementById('AMLTabDiv-' + WViewModel.RAId()).innerHTML = TabDataOverAll;
            ko.applyBindingsToNode($('#btnAMLSaveOverall'), { click: WViewModel.saveWeightings }, WViewModel);
            ko.applyBindingsToNode($('#btnAMLCopyOverall'), { click: WViewModel.copyData }, WViewModel);

            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1); k++) {
                    ko.applyBindingsToNode($('#txt_Oweighting' + i + '_' + k), { event: { keyup: WViewModel.InputChange } }, WViewModel);
                }
            }
            //for (var i = 0; i < WViewModel.BusinessUnitsList().length; i++) {
            //    ko.applyBindingsToNode($('#txt_Oweighting' + i + WViewModel.RAId()), { event: { keyup: WViewModel.InputChange } }, WViewModel);
            //}
            ImplementOverallTableSecurity();
            $("#clscroll-content" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-row-headers" + WViewModel.RAId()).scrollTop($("#clscroll-content" + WViewModel.RAId()).scrollTop());
                $("#clscroll-column-headers" + WViewModel.RAId()).scrollLeft($("#clscroll-content" + WViewModel.RAId()).scrollLeft());
                $("#clscroll-column-footer" + WViewModel.RAId()).scrollLeft($("#clscroll-content" + WViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-headers" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + WViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + WViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-footer" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + WViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + WViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-row-headers" + WViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + WViewModel.RAId()).scrollTop($("#clscroll-row-headers" + WViewModel.RAId()).scrollTop());
            });
            $('#loadingMainImgDivAMLRA_WIA').hide();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallWeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
            $('#loadingMainImgDivAMLRA_WIA').hide();
            $('#RiskAreaTabDiv').show();
        }
    }
    function ImplementOverallTableSecurity() {
        try {
            if (WViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblAMLWeightingsOverall tbody').find('input').length; i++) {
                    $($('#tblAMLWeightingsOverall tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallWeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    //Building Overallweightings and security for the table ends here

    //risk area tab click ends here
    //------------------------------------------------------------------------Model Defination starts here----------------------------------------------------------
    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            if ($('<div/>').html(item.IsQualitative).text() == "1") {
                self.IsQualitative = ko.observable(true);
            }
            else {
                self.IsQualitative = ko.observable(false);
            }
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    };
    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    };
    function WeightingModel(item) {
        try {
            var self = this;
            self.Id = ko.observable(item.Id);
            self.BuId = ko.observable(item.BuId);
            self.WeightingValue = ko.observable(item.WeightingValue);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingModel() method in WeightingsandThresholds.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

});
